import { combineReducers } from 'redux'
import type { PlaylistReportState } from './reports/playlistReport'
import { playlistReportReducer } from './reports/playlistReport'
export type ReportsState = {
  playlistReport: PlaylistReportState
}
// reducer combines reports reducers
export const reportsReducer = combineReducers({
  playlistReport: playlistReportReducer,
})
